import React, { memo } from "react";
import VALIDTHRU from "../../../assets/images/VALIDTHRU.png";
import debit_icon from "../../../assets/images/debit_icon.svg";
import visa_icon from "../../../assets/images/visa_icon.svg";
import jcb_icon from "../../../assets/images/jcb_icon.svg";
import mastercard from "../../../assets/images/mastercard.svg";
import americanexpress from "../../../assets/images/american-express.svg";
import discover_card from "../../../assets/images/discover_card.svg";
import {
  CardLayoutMain,
  CardType,
  CardNumber,
  CardName,
  CardDateMain,
} from "./styles/CardLayoutStyle";
import { getCardType } from "../../../helpers/getCardType";

const CardLayout = ({ CardNumbers, cardName, expirationDate, cardType }) => {
  //   const cardNumber = "1234567890123456";
  const cardNumber = CardNumbers ? CardNumbers : "****************";
  // const formattedCardNumber = cardNumber.replace(/(.{4})/g, "$1 ");
  const CardNameText = cardName ? cardName : "Card name";
  const expirationDatetext = expirationDate ? expirationDate : "00/0000";
  const ViewCardType =
    cardType && cardType === "Invalid"
      ? ""
      : cardType === "Unknown"
      ? ""
      : cardType;
  const CardsType = CardNumbers && getCardType(CardNumbers);
  const CardsTypeValue = CardsType.toLowerCase();

  return (
    <div className="card_layout">
      <CardLayoutMain>
        <CardType className="CardType">{ViewCardType}</CardType>
        <CardNumber>{cardNumber}</CardNumber>
        <CardName>{CardNameText}</CardName>
        <CardDateMain>
          <div className="date">
            <img src={VALIDTHRU} alt="VALIDTHRU" />
            <span>{expirationDatetext}</span>
          </div>
          <div className="CardType_image">
            {CardsTypeValue === "visa" ? (
              <img src={visa_icon} alt="visa card" />
            ) : CardsTypeValue === "debit" ? (
              <img src={debit_icon} alt="debit card" />
            ) : CardsTypeValue === "jcb" ? (
              <img src={jcb_icon} alt="jcb card" />
            ) : CardsTypeValue === "mastercard" ? (
              <img src={mastercard} alt="master card" />
            ) : CardsTypeValue === "amex" ? (
              <img src={americanexpress} alt="amex card" />
            ) : CardsTypeValue === "discover" ? (
              <img src={discover_card} alt="discover card" />
            ) : (
              ""
            )}
          </div>
        </CardDateMain>
      </CardLayoutMain>
    </div>
  );
};

export default memo(CardLayout);
